/**
 * Recursively transforms any key named "id" or ending with "_id"
 * from string -> number (if the string is numeric).
 */
import {AxiosResponse} from 'axios';

export function transformedResponse(data: AxiosResponse): AxiosResponse | unknown {
  if (data instanceof Date) {
    return data.toISOString();
  }

  // 1) If "data" is an array, recursively transform each element.
  if (Array.isArray(data)) {
    return data.map((item) => transformedResponse(item));
  }

  // 2) If "data" is a plain object, iterate its keys.
  if (data !== null && typeof data === 'object') {
    const transformed: Record<string, unknown> = {};

    for (const [key, value] of Object.entries(data)) {
      // Check if the key is "id" or ends with "_id"
      if (key === 'id' || key.endsWith('_id')) {
        // Convert string to number only if it's numeric
        if (typeof value === 'string' && !isNaN(Number(value))) {
          transformed[key] = Number(value);
        } else {
          transformed[key] = value;
        }
      } else {
        // Recursively transform nested objects/arrays
        transformed[key] = transformedResponse(value);
      }
    }
    return transformed;
  }

  // 3) If it's neither array nor object (like string, number, etc.), return as-is.
  return data;
}
